import { render, staticRenderFns } from "./DownloadInventory.vue?vue&type=template&id=1ae5715d&scoped=true&"
var script = {}
import style0 from "./DownloadInventory.vue?vue&type=style&index=0&id=1ae5715d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae5715d",
  null
  
)

export default component.exports